import { BrowserRouter } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { AppRoutes } from './router';
import StaggeredMenu from './components/feature/StaggeredMenu';
import Footer from './components/feature/Footer';
import CookieConsent from './components/feature/CookieConsent';
import CookieSettings from './components/feature/CookieSettings';
import CookieManager from './components/feature/CookieManager';
import AccessibilityButton from './components/feature/AccessibilityButton';
import UnderConstructionOverlay from './components/feature/UnderConstructionOverlay';

function App() {
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  useEffect(() => {
    const handleOpenCookieSettings = () => {
      setShowCookieSettings(true);
    };

    window.addEventListener('openCookieSettings', handleOpenCookieSettings);
    
    return () => {
      window.removeEventListener('openCookieSettings', handleOpenCookieSettings);
    };
  }, []);

  const handleAcceptAll = () => {
    // Handle accept all cookies
    console.log('All cookies accepted');
  };

  const handleAcceptNecessary = () => {
    // Handle accept necessary cookies only
    console.log('Only necessary cookies accepted');
  };

  const handleShowSettings = () => {
    setShowCookieSettings(true);
  };

  const handleSaveSettings = (settings: Record<string, boolean>) => {
    // Handle save custom cookie settings
    console.log('Cookie settings saved:', settings);
  };

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <StaggeredMenu />
      <UnderConstructionOverlay />
      <AppRoutes />
      <Footer />
      <CookieConsent
        onAcceptAll={handleAcceptAll}
        onAcceptNecessary={handleAcceptNecessary}
        onShowSettings={handleShowSettings}
      />
      <CookieSettings
        isOpen={showCookieSettings}
        onClose={() => setShowCookieSettings(false)}
        onSave={handleSaveSettings}
      />
      <CookieManager />
      <AccessibilityButton />
    </BrowserRouter>
  );
}

export default App;
